import { createCustomTheme } from '@domains/subscription/theme'
import { Button, Dialog, Stack, ThemeProvider, Typography } from '@mui/material'
import type { DefaultConfig } from '../Templates/types'

interface DeleteDefaultConfigDialogProps {
  config: DefaultConfig
  open: boolean
  onClose: () => void
  onDelete: () => void
}

export const DeleteDefaultConfigDialog = ({ open, onClose, onDelete, config }: DeleteDefaultConfigDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <ThemeProvider theme={createCustomTheme()}>
        <Stack
          sx={{
            gap: 3,
            padding: 3,
          }}
        >
          <Stack
            sx={{
              gap: 1,
            }}
          >
            <Typography variant="h2">{`Are you sure you want to delete this default config?`}</Typography>
            <Typography variant="p3Regular" color="textSecondary">
              This will remove the default config for {config.channel.type} — {config.channel.channelId}.
            </Typography>
          </Stack>
          <Stack
            sx={{
              alignSelf: 'flex-end',
              flexDirection: 'row',
              gap: 2,
            }}
          >
            <Button size="medium" variant="tertiary" onClick={onClose}>
              Cancel
            </Button>
            <Button size="medium" color="error" variant="contained" onClick={onDelete}>
              Delete
            </Button>
          </Stack>
        </Stack>
      </ThemeProvider>
    </Dialog>
  )
}
